import { LogLevel } from "@azure/msal-browser";

const tenantId = process.env.REACT_APP_TENANT_ID;
const clientId = process.env.REACT_APP_CLIENT_ID;
const backendClientId = process.env.REACT_APP_BACKEND_CLIENT_ID;

console.log(tenantId);
console.log(clientId);
console.log(backendClientId);

if (!tenantId || !clientId || !backendClientId) {
  console.error("❌ MSAL ENV ERROR", {
    tenantId,
    clientId,
    backendClientId,
  });
}

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,

    // ✅ CRITICAL (prevents iframe reload issues)
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,

    // ✅ Prevents redirect loops
    navigateToLoginRequestUrl: false,
  },

  cache: {
    cacheLocation: "sessionStorage", // ✅ best for stability
    storeAuthStateInCookie: false,
  },

  system: {
    allowRedirectInIframe: false, // 🔥 FIXES block_iframe_reload

    loggerOptions: {
      logLevel: LogLevel.Warning,
      loggerCallback: (level, message) => {
        if (level >= LogLevel.Warning) {
          console.warn(message);
        }
      },
    },
  },
};

// ✅ SINGLE SOURCE OF TRUTH (IMPORTANT)
export const loginRequest = {
  scopes: [`api://${backendClientId}/access_as_user`],
};